import { combineReducers }         from 'redux';
import { routerReducer as router } from 'react-router-redux';
import { reducer as oidc }         from 'redux-oidc';
import restaurant                  from './restaurant';
import tenant                      from './tenant';
import capabilities                from './capabilities';
import subscriptions               from './subscriptions';

export default combineReducers({
    router,
    oidc,
    restaurant,
    tenant,
    capabilities,
    subscriptions
});



// WEBPACK FOOTER //
// /src/store/reducers/index.js